import { useContext } from 'react';
import { useLocalObservable } from 'mobx-react';
import PackageService from '@/Services/PackageService';
import PackageServiceContext from '@/Contexts/PackageServiceContext';
import { useApi } from '@/Util/useApi';

function usePackageService(): PackageService {
  const context = useContext(PackageServiceContext);
  const packageService: PackageService = useLocalObservable<PackageService>(() => context);

  packageService.api = useApi();

  return packageService;
}

export default usePackageService;
